import { ref } from 'vue'
import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

const error = ref(null)

export const resetMyPassword = async (username, reset_code, password) => {
    log("resetMyPassword called with username: " + username + ", code: " + reset_code)
    error.value = null
    try {
        const result = await axios.post(`${BASE_URL}/home/resetPassword`, {
            username: username,
            reset_code: reset_code,
            new_password: password
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        error.value = null
        log("resetMyPassword result:")
        log(result.data)
        // Parse JSON string if needed
        if (typeof result.data === 'string') {
            return JSON.parse(result.data)
        }
        return result.data
    } catch (err) {
        log("Error in resetMyPassword:")
        log(err)
        error.value = "Eroare la resetarea parolei"
        return { error: true, message: "Eroare la resetarea parolei" }
    }
}

const useResetPassword = () => {
    return { error, resetMyPassword }
}
export default useResetPassword
